
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admissions-day/[slug]",
      function () {
        return require("private-next-pages/admissions-day/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admissions-day/[slug]"])
      });
    }
  